import factory from './icon';
import Svg from './glyphs/arrow-left.svg';

export default factory(Svg);
